export default "__VITE_ASSET__BIfOB4ai__"